import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  getBoldLabelText,
  getNormalLabelText,
} from '../../../util/Insight360Utils';
import { BRAND_ICON_LIST } from '../../../constants';
import * as insight360Actions from '../../../actions/insight360Actions';

const getImageIcon = imageKey => {
  let selectedIcon;
  const imageComponent = _.find(BRAND_ICON_LIST, { id: imageKey });
  if (imageComponent !== undefined) {
    selectedIcon = imageComponent.selectedIcon;
  }
  return selectedIcon;
};

const renderDeepDiveSlider = (value, personaIndex, subCategory,
  selectedTab, displayDeepDiveSlider) => {
  const deepDivePersonaObject = {
    personaIndex,
    category: subCategory,
    section: 'Brands',
    selectedTab,
  };
  displayDeepDiveSlider(value, deepDivePersonaObject);
};


const BrandsComparisionDetail = ({
  brandCategory,
  selectedIcon,
  statement,
  brandDetail,
  personaIndex,
  selectedTab,
  displayDeepDiveSlider,
}) => (<div>
  {brandCategory !== undefined && (
    <div className="attitude-detail-comparision-grid pointer-cursor"
    onClick={() => {
      renderDeepDiveSlider(true, personaIndex,
        brandDetail.brandSubCategory, selectedTab, displayDeepDiveSlider);
    }}
    >
      <div className="attitude-comparision-float">
        <div className="attitude-float">
          <div className="attitude-comparision-image-border attitude-float">
            {getImageIcon(selectedIcon) === undefined && (
              <div className="imageblock" />
            )}
            {getImageIcon(selectedIcon) !== undefined && (<img
              alt="icon"
              role="presentation"
              className="i360-demo-double-comparision-img"
              src={getImageIcon(selectedIcon)}
            />
            )}
            <div className="attitude-comparision-icon-labels">
              {brandCategory}{' '}
            </div>
          </div>
        </div>
        <div>
          <div className="div-overflow">
            <div
              className="attitude-comparision-labels"
              title={statement}
            >
              <p className="brand-block-with-text">
                <span style={{ fontWeight: 'bold' }}>
                  {getBoldLabelText(statement)}
                </span>
                <span>{getNormalLabelText(statement)}</span>
              </p>
            </div>
          </div>
          <div className="div-overflow">
            <div className="attitude-triple-comparision-metrics">
              INDEX:&nbsp;&nbsp;{brandDetail.index} |
              REACH:&nbsp;&nbsp;{brandDetail.pct}{' '}
            </div>
          </div>
        </div>
      </div>
    </div>
  )}
</div>
);

BrandsComparisionDetail.propTypes = {
  brandCategory: PropTypes.string,
  selectedIcon: PropTypes.string,
  statement: PropTypes.string,
  brandDetail: PropTypes.shape({
    brandSubCategory: PropTypes.string, 
    index: PropTypes.number,
    pct: PropTypes.number
  }),
  displayDeepDiveSlider: PropTypes.func,
  personaIndex: PropTypes.number,
  selectedTab: PropTypes.string,
};


function mapDispatchToProps(dispatch) {
  const displayDeepDiveSlider = (value, deepDivePersonaObject) => {
    dispatch(insight360Actions.showDeepDivePopup(value, deepDivePersonaObject));
  };
  return {
    displayDeepDiveSlider,
  };
}

export default connect(
  null,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(BrandsComparisionDetail);
